import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, CheckCircle } from 'lucide-react';
import api from '../api';

const SetupUsername = ({ user, onComplete }) => {
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim()) {
      setMessage('Please enter a username');
      setMessageType('error');
      return;
    }

    if (username.length < 3) {
      setMessage('Username must be at least 3 characters long');
      setMessageType('error');
      return;
    }

    if (!/^[a-zA-Z0-9_]+$/.test(username)) {
      setMessage('Username can only contain letters, numbers, and underscores');
      setMessageType('error');
      return;
    }

    setLoading(true);
    setMessage('');

    try {
      const response = await api.post('/api/auth/setup-username', { 
        username,
        telegramId: user.telegram_id 
      });
      
      if (response.data.success) {
        // Update user data with username
        const updatedUser = { ...user, username };
        onComplete(updatedUser);
        
        setMessage('Username set successfully! Redirecting to dashboard...');
        setMessageType('success');
        
        setTimeout(() => {
          navigate('/dashboard');
        }, 2000);
      } else {
        setMessage(response.data.message || 'Failed to set username');
        setMessageType('error');
      }
    } catch (error) {
      setMessage(error.response?.data?.message || 'Failed to set username');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="card" style={{ maxWidth: '500px', margin: '2rem auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <CheckCircle size={48} color="#38a169" />
          <h1 style={{ marginTop: '1rem' }}>
            Welcome to Expense Tracker!
          </h1>
          <p style={{ color: '#4a5568', marginTop: '0.5rem' }}>
            Set up your username to get started
          </p>
        </div>

        {message && (
          <div className={`alert alert-${messageType}`}>
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="username">
              <User size={16} style={{ marginRight: '8px' }} />
              Choose a Username
            </label>
            <input
              type="text"
              id="username"
              className="input"
              value={username}
              onChange={(e) => setUsername(e.target.value.toLowerCase())}
              placeholder="Enter your desired username"
              disabled={loading}
            />
            <small style={{ color: '#4a5568', marginTop: '0.5rem', display: 'block' }}>
              • Must be at least 3 characters long<br/>
              • Can only contain letters, numbers, and underscores<br/>
              • This will be your login username
            </small>
          </div>

          <div className="glass-light" style={{ 
            padding: '1rem', 
            marginBottom: '1rem' 
          }}>
            <h4 style={{ marginBottom: '0.5rem' }}>
              Your Telegram Info:
            </h4>
            <p style={{ margin: '0.25rem 0', color: '#4a5568' }}>
              <strong>ID:</strong> {user.telegram_id}
            </p>
            <p style={{ margin: '0.25rem 0', color: '#4a5568' }}>
              <strong>Name:</strong> {user.first_name} {user.last_name || ''}
            </p>
            <p style={{ margin: '0.25rem 0', color: '#4a5568' }}>
              <strong>Username:</strong> @{user.username || 'Not set'}
            </p>
          </div>

          <button 
            type="submit" 
            className="btn" 
            style={{ width: '100%' }}
            disabled={loading}
          >
            {loading ? 'Setting Username...' : 'Set Username & Continue'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SetupUsername; 